import moment from 'moment';
import { ObjectHelper } from '@/mixins/objectHelper';
import { BrowserLocale, DateFormat } from '@/types';
import MultiFilterItem from '@/classes/MultiFilterItem';

export const BTableHelpers = {
  data(this: any) {
    return {
      tableFields: []
    };
  },
  methods: {
    date(value: string) {
      if (!value) {
        return null;
      }

      const locale = window.navigator.language;
      const inputFormat = value.isUkShortDateFormat() ? DateFormat.UK : DateFormat.IsoFormat;
      const targetFormat = inputFormat === DateFormat.IsoFormat ? 'L LT' : locale.toLowerCase() === BrowserLocale.US ? DateFormat.US : DateFormat.UK;
      return moment(value, inputFormat)
        .locale(locale)
        .format(targetFormat);
    },
    dateWithoutTime(value: string) {
      if (!value) {
        return null;
      }

      const locale = window.navigator.language;
      const inputFormat = value.isUkShortDateFormat() ? DateFormat.UK : DateFormat.IsoFormat;
      const targetFormat = inputFormat === DateFormat.IsoFormat ? 'L' : locale.toLowerCase() === BrowserLocale.US ? 'L' : DateFormat.UK;
      return moment(value, inputFormat)
        .locale(locale)
        .format(targetFormat);
    },
    twoDecimalPlaces(value: number | string) {
      const numberValue = Number(value);
      return numberValue.toFixed(2);
    },
    objectCollection(value: []) {
      return !value || value.length === 0 ? '' : JSON.stringify(value);
    },
    tableFilterFields(this: any, fields: any) {
      this.tableFields = fields;
      return this.tableFields;
    },
    tableFilter(this: any, row: any, searchText: any): boolean {
      const fields = this.fields ? this.fields : this.tableFields;
      return this.customTableFilter(fields, row, searchText);
    },
    getKey(field: any) {
      if (!field) {
        return '';
      }

      const keys = Object.keys(field);
      return keys.indexOf('key') > -1 ? field.key : keys[0];
    },
    customTableFilter(fields: any, row: any, searchText: any): boolean {
      let filteredRow = false;

      fields.some((field: any) => {
        const key = this.getKey(field);
        let value = key.contains('.') && !row[key] ? ObjectHelper.methods.getNestedPropertyValue(key.split('.'), row) : row[key];

        if (field.formatter) {
          const thisElement: { [index: string]: any } = this;

          let formatter = field.formatter;

          if (typeof formatter === 'string' && typeof thisElement[formatter] === 'function') {
            formatter = thisElement[formatter];
          }
          value = formatter(value, key, row);
        }

        if (value && value.toString().contains(searchText)) {
          filteredRow = true;
          return filteredRow;
        }
      });
      return filteredRow;
    },
    customTableMultiFilter(fields: any, row: any, searchItems: MultiFilterItem[]): boolean {
      return searchItems
        .map((si) => si.value.trim())
        .filter((v) => v)
        .every((v) => this.customTableFilter(fields, row, v));
    },
    customTableSort(rows: any, sortBy: any, sortByDes: boolean = false) {
      if (!ObjectHelper.methods.isNullOrEmpty(sortBy)) {
        rows.sort((x: any, y: any) => (x[sortBy] > y[sortBy] ? 1 : -1));
        if (sortByDes) {
          rows.reverse();
        }
      }
      return rows;
    }
  }
};
